import createDisplayName from "../../../../fabrics/createDisplayName";
import { HEADER_DISPLAY_NAME } from "../Header";

export const createDisplayNameForHeader =
    createDisplayName(HEADER_DISPLAY_NAME);
